import { makeAutoObservable, runInAction } from 'mobx';
import { v4 } from 'uuid';

import { cmApi } from '@src/api';
import type { CmApi, UserFilterDto } from '@src/api';

import { isChangedAllReference } from '../dictionaryStores/fetchReferences';
import { preloaderStore } from '../preloaderStore';

export type UserFilterDtoDefId = Omit<UserFilterDto, 'groupFilter' | 'organizationFilter'> & {
  id: string;
  groupFilter?: string[];
  organizationFilter?: string[];
};

class SettingUserRolesStore {
  userFilter: UserFilterDtoDefId[] = [];

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  setUserFilter = (values: UserFilterDtoDefId) => {
    const out = [...this.userFilter];
    const idx = out.findIndex((item) => item.id === values.id);

    out.splice(idx, 1, values);

    this.userFilter = out;
  };

  getUserFilters = async (): Promise<void> => {
    preloaderStore.preloader(true);

    try {
      const { data } = await this.api.userFiltres.getUserFilters();

      runInAction(() => {
        this.userFilter = data
          ? data.map((item) => ({
              ...item,
              id: item.id ?? v4(),
              groupFilter: item.groupFilter?.split(',').sort(),
              organizationFilter: item.organizationFilter?.split(',').sort(),
            }))
          : [];
      });
    } catch (error) {
      console.error(error);
    }

    preloaderStore.preloader(false);
  };

  processUserFilters = async (): Promise<void> => {
    preloaderStore.preloader(true);

    try {
      const out = this.userFilter.map((item) => ({
        ...item,
        groupFilter: item.groupFilter?.length ? item.groupFilter?.join(',') : undefined,
        organizationFilter: item.organizationFilter?.length ? item.organizationFilter?.join(',') : undefined,
      }));

      const res = await this.api.userFiltres.processUserFilters(out);

      if (res.status === 200) {
        this.getUserFilters();
        isChangedAllReference();
      }
    } catch (error) {
      console.error(error);
    }

    preloaderStore.preloader(false);
  };
}

export const settingUserRolesStore = new SettingUserRolesStore({ api: cmApi });
